// extracted by mini-css-extract-plugin
export var avatarContainer = "_3t-1";
export var largeAvatarContainer = "_3t-2";
export var smallAvatarContainer = "_3t-0";